module.exports = __webpack_public_path__ + "static/media/web-icon.de9cfc44.png";